/* @ngInject */
const logsResource = () => {
  const self = {}

  self.error = {
    server: 'Impossible de se connecter au serveur',
    '404': 'La page est introuvable',
    '403': 'l\'accès est interdit',
  }
  self.date = {
    invalid: 'Cette date est invalide',
    required: 'Cette date est requise',
  }
  self.input = {
    invalid: 'Ce champ est invalide',
    required: 'Ce champ est obligatoire',
    maxlength: 'Ce champ est trop long',
    minlength: 'Ce champ est trop cours',
    number: 'Valeur incorrecte (format: 0-9)',
    email: 'Adresse incorrecte (format: abc@abc.com)',
  }
  self.switch = {
    yes: 'oui',
    no: 'non',
  }
  self.noElementsFound = 'Aucun élément ne correspond à la recherche'
  self.phone = {
    invalid: 'Le numéro de téléphone est invalide',
  }

  return self
}
export default logsResource



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/resources/logs.resource.js